import {siteURL, woocomPart, consumerKey, consumerSecret} from '../utils/constants';

export async function getNameProductsApi(nVProducto) {
    
    try {
        const parmas = {
            method: "GET",
            headers: {
              "content-Type": "application/json",
            }
        }
      const url = `${siteURL}${woocomPart}products/${nVProducto}?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}`;
      const response = await fetch(url, parmas);
      const result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  export async function getProductApi(idProducto) {
    
    try {
        const parmas = {
            method: "GET",
            headers: {
              "content-Type": "application/json",
            }
        }
      const url = `${siteURL}${woocomPart}products/${idProducto}?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}`;
      const response = await fetch(url, parmas);
      const result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
